/**
 * Wire enums for the backend search API (DEV-1133).
 *
 * The string values are the C# enum member names exactly, because that is what the backend
 * deserializes them into. Do not camelCase them to match frontend convention - these are not
 * frontend values, they are the other end of a contract.
 */

/**
 * What kind of value a filter item carries.
 *
 * This is sent explicitly rather than inferred, which is the point. The code this replaced
 * inferred the kind by inspecting the value, and its two type guards both opened with a
 * truthiness test - so a boolean filter whose value was `false` was misread as a date range and
 * silently produced no filter at all.
 */
export enum SearchFilterValueKindEnum {
    Text = 'Text',
    Boolean = 'Boolean',
    DateRange = 'DateRange',
    YearRange = 'YearRange',
    NumberRange = 'NumberRange'
}

/** How an item is matched against its field. */
export enum SearchFilterMatchEnum {
    /** Scalar equality. */
    Equals = 'Equals',
    /** Membership in a collection field. */
    CollectionContains = 'CollectionContains',
    /** A bounded range. */
    Range = 'Range'
}

/** How the items within one filter set are joined. */
export enum SearchFilterJoinEnum {
    And = 'And',
    Or = 'Or'
}

/**
 * Which index a search targets.
 *
 * An enum rather than a free-text name, so the index a caller can reach is a closed set and the
 * URL path is not something the client composes.
 */
export enum SearchIndexEnum {
    Studies = 'studies',
    Vocab = 'vocab'
}
